import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DashboardLayout } from '../components/dashboard-layout.js';

export const Route = createFileRoute('/admin/$slug')({
  component: AdminLayout,
});

function AdminLayout() {
  const { slug } = Route.useParams();
  return (
    <DashboardLayout slug={slug}>
      <Outlet />
    </DashboardLayout>
  );
}
